var _path, _g, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M444.708,349.145H263.962c-3.232,0-5.862-2.63-5.862-5.862V80.009 c0-3.232,2.63-5.862,5.862-5.862h180.746c3.232,0,5.862,2.629,5.862,5.862v263.273 C450.57,346.515,447.94,349.145,444.708,349.145z M263.962,74.397c-3.095,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612h180.746c3.095,0,5.612-2.518,5.612-5.612V80.009c0-3.094-2.518-5.612-5.612-5.612H263.962z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M236.28,349.145H55.534c-3.232,0-5.862-2.63-5.862-5.862V80.009 c0-3.232,2.629-5.862,5.862-5.862H236.28c3.232,0,5.862,2.629,5.862,5.862v263.273 C242.143,346.515,239.513,349.145,236.28,349.145z M55.534,74.397c-3.094,0-5.612,2.518-5.612,5.612v263.273 c0,3.095,2.518,5.612,5.612,5.612H236.28c3.095,0,5.612-2.518,5.612-5.612V80.009c0-3.094-2.518-5.612-5.612-5.612H55.534z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.788,
    y: 410.214,
    style: {
      fill: "#E0E0E0"
    },
    width: 500,
    height: 0.25
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M470.397,291.426h-190l0,0c0,3.216,2.607,5.824,5.824,5.824h178.352 C467.789,297.25,470.397,294.643,470.397,291.426L470.397,291.426z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 319.433,
    y: 346.512,
    style: {
      fill: "#E0E0E0"
    },
    width: 113.646,
    height: 5.389
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "429.057,410.284 444.548,297.25 439.108,297.25 423.617,410.284  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "441.793,410.284 426.052,297.25 431.492,297.25 447.233,410.284  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "310.737,410.284 326.891,297.25 321.451,297.25 305.297,410.284  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "323.473,410.284 307.982,297.25 313.422,297.25 328.913,410.284  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.022,
    y: 282.079,
    style: {
      fill: "#E6E6E6"
    },
    width: 202.75,
    height: 9.384
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M347.093,282.114h87.984l0.955-2.16c0.601-1.359-0.966-2.713-3.139-2.713h-81.186 c-1.456,0-2.737,0.627-3.139,1.538L347.093,282.114z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M459.199,220.868l-11.262,47.633c-0.301,1.27-1.433,2.166-2.738,2.166h-69.379 c-1.815,0-3.156-1.694-2.738-3.46l11.262-47.633c0.301-1.269,1.433-2.166,2.738-2.166h69.378 C458.276,217.408,459.617,219.102,459.199,220.868z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M425.489,245.899c-0.331,2.998-3.029,5.428-6.027,5.428s-5.161-2.43-4.83-5.428 c0.33-2.998,3.029-5.428,6.027-5.428S425.819,242.901,425.489,245.899z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M389.831,217.408l-11.991,53.259h-2.02c-1.815,0-3.156-1.694-2.738-3.46l11.262-47.633 c0.301-1.269,1.433-2.166,2.738-2.166H389.831z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "409.928,270.666 407.563,281.981 414.514,281.981 416.879,270.666  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.419,280.066l1.423-2.001c0.508-0.714,1.33-1.139,2.207-1.139h19.059 c1.008,0,1.933,0.56,2.4,1.454l0.96,1.835c0.449,0.858-0.174,1.886-1.142,1.886H398.47 C397.422,282.103,396.812,280.92,397.419,280.066z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "369.091,128.796 368.517,127.885 402.003,106.786 434.666,128.357 434.072,129.256  401.989,108.069  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 367.945,
    y: 127.939,
    style: {
      fill: "#E0E0E0"
    },
    width: 67.436,
    height: 42.178
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.442,
    y: 117.179,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 550.6906 -252.634)",
    style: {
      fill: "#FFFFFF"
    },
    width: 38.441,
    height: 63.699
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.795,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.07,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.344,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.619,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.894,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.168,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.443,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.718,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.993,
    y: 141.861,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.795,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.07,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.344,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.619,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.894,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.168,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.443,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.718,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.993,
    y: 147.462,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.795,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.07,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.344,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.619,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.894,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.168,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.443,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.718,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.993,
    y: 153.063,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.795,
    y: 159.087,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.07,
    y: 159.087,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.344,
    y: 159.087,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.619,
    y: 159.087,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.071,
    height: 4.071
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 383.825,
    y: 133.57,
    style: {
      fill: "#E0E0E0"
    },
    width: 36.209,
    height: 3.516
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M404.15,107.17c0,1.129-0.915,2.044-2.045,2.044c-1.129,0-2.044-0.915-2.044-2.044 c0-1.129,0.915-2.045,2.044-2.045C403.235,105.126,404.15,106.041,404.15,107.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 272.823,
    y: 86.412,
    style: {
      fill: "#F0F0F0"
    },
    width: 70.319,
    height: 170.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.11,
    y: 90.705,
    style: {
      fill: "#FAFAFA"
    },
    width: 61.74,
    height: 162.27
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "338.85,97.655 338.85,109.905 277.11,171.655 277.11,159.395  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "338.85,140.025 338.85,157.305 277.11,219.045 277.11,201.755  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.857,
    y: 86.412,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.25,
    height: 170.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 149.219,
    y: 86.412,
    style: {
      fill: "#F0F0F0"
    },
    width: 70.319,
    height: 170.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.507,
    y: 90.705,
    style: {
      fill: "#FAFAFA"
    },
    width: 61.74,
    height: 162.27
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "215.247,97.655 215.247,109.905 153.507,171.655 153.507,159.395  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "215.247,140.025 215.247,157.305 153.507,219.045 153.507,201.755  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.254,
    y: 86.412,
    style: {
      fill: "#F0F0F0"
    },
    width: 4.25,
    height: 170.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M171.137,387.394c0,0-8.499,1.883-7.236-4.047c1.263-5.93,1.17-8.116-2.284-10.811 c-3.454-2.695-6.93-4.026-4.285-8.294c2.645-4.268-2.374-7.585-4.967-9.882c-2.594-2.297,0.334-4.029,1.021-8.371 c0.687-4.342-3.984-3.69-4.351-9.159c-0.367-5.469,5.189-11.861,0.412-19.389c0,0,6.416,3.327,8.524,9.172 c2.108,5.845,0.406,10.36,4.196,12.581c3.79,2.222,6.163,6.064,4.876,10.008c-1.288,3.944,0.542,6.035,3.649,8.911 c3.107,2.876,2.28,4.019,1.893,7.536c-0.386,3.517,0.39,2.685,3.947,7.49 C180.09,377.945,180.18,385.818,171.137,387.394z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M172.347,387.132c-0.018-0.029-0.033-0.058-0.043-0.091l-17.006-51.616 c-0.073-0.221,0.048-0.461,0.269-0.534c0.003-0.001,0.005-0.001,0.008-0.002c0.22-0.068,0.455,0.053,0.527,0.272 l17.005,51.615c0.014,0.041,0.02,0.084,0.022,0.126L172.347,387.132z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M186.472,387.287c0,0,8.454,1.873,7.198-4.025c-1.256-5.898-1.164-8.073,2.272-10.754 c3.436-2.681,6.894-4.005,4.262-8.25c-2.631-4.245,2.361-7.545,4.941-9.829c2.58-2.285-0.332-4.008-1.016-8.327 c-0.683-4.319,3.963-3.67,4.328-9.111c0.365-5.441-5.162-11.799-0.41-19.287c0,0-6.382,3.31-8.479,9.124 c-2.096,5.814-0.404,10.305-4.174,12.515c-3.77,2.21-6.131,6.032-4.85,9.955c1.281,3.923-0.539,6.003-3.63,8.864 c-3.091,2.861-2.268,3.998-1.884,7.496c0.384,3.498-0.387,2.671-3.926,7.45 C177.567,377.888,177.477,385.72,186.472,387.287z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M184.49,386.796c0.001-0.042,0.007-0.084,0.021-0.126l16.915-51.341 c0.072-0.219,0.306-0.339,0.525-0.271c0.003,0.001,0.005,0.002,0.008,0.003c0.22,0.073,0.34,0.311,0.267,0.531 l-16.915,51.342c-0.01,0.033-0.025,0.063-0.043,0.091L184.49,386.796z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M177.085,386.213c0,0-9.728-0.806-6.406-6.737c3.322-5.932,3.949-8.304,1.144-12.338 c-2.805-4.034-6.086-6.614-1.835-10.306c4.25-3.692-0.023-8.912-2.039-12.234c-2.015-3.322,1.696-4.204,3.874-8.627 c2.178-4.423-3.042-5.275-1.618-11.255c1.424-5.98,9.497-10.981,6.881-20.63c0,0,5.767,5.695,6.084,12.655 c0.316,6.96-3.005,11.231,0.316,14.87c3.322,3.638,4.587,8.542,1.898,12.338c-2.689,3.797-1.424,6.644,0.949,10.757 c2.373,4.113,1.107,5.062-0.475,8.7c-1.582,3.638-0.475,3.006,1.74,9.333C189.813,379.065,187.295,387.529,177.085,386.213 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M178.469,386.334c-0.01-0.037-0.016-0.073-0.016-0.112l-1.073-60.932 c-0.005-0.261,0.204-0.478,0.465-0.482c0.003,0,0.006,0,0.01,0c0.258,0,0.47,0.207,0.475,0.467l1.072,60.93 c0.002,0.049-0.006,0.097-0.019,0.142L178.469,386.334z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M203.574,381.507h-47.579c-1.368,0-2.314,1.366-1.831,2.647l0.704,1.868l0.445,1.184 l1.277,3.39l0.447,1.184l1.312,3.481l0.444,1.182l5.234,13.897h31.517l5.234-13.897l0.445-1.182l1.312-3.481l0.447-1.184 l1.277-3.39l0.445-1.184l0.704-1.868C205.886,382.873,204.941,381.507,203.574,381.507z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 89.915,
    cy: 111.238,
    r: 17.153
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1655 -0.9862 0.9862 0.1655 -34.6686 181.5057)",
    style: {
      fill: "#FAFAFA"
    },
    cx: 89.915,
    cy: 111.238,
    rx: 15.801,
    ry: 15.801
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.366,
    y: 96.873,
    style: {
      fill: "#E0E0E0"
    },
    width: 0.591,
    height: 3.296
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.366,
    y: 122.223,
    style: {
      fill: "#E0E0E0"
    },
    width: 0.591,
    height: 3.295
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.339,
    y: 110.9,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.296,
    height: 0.592
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.689,
    y: 110.9,
    style: {
      fill: "#E0E0E0"
    },
    width: 3.295,
    height: 0.592
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.976,
    y: 101.938,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -43.4039 99.6981)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.296,
    height: 0.592
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.051,
    y: 119.863,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -61.332 92.2733)",
    style: {
      fill: "#E0E0E0"
    },
    width: 3.295,
    height: 0.592
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.403,
    y: 100.586,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -48.6537 87.0062)",
    style: {
      fill: "#E0E0E0"
    },
    width: 0.592,
    height: 3.296
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.328,
    y: 118.511,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -56.0804 104.9497)",
    style: {
      fill: "#E0E0E0"
    },
    width: 0.592,
    height: 3.296
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.999,
    y: 109.138,
    transform: "matrix(0.3664 -0.9305 0.9305 0.3664 -45.8893 156.8941)",
    style: {
      fill: "#E0E0E0"
    },
    width: 0.507,
    height: 6.005
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "89.915,111.449 80.699,111.449 80.699,110.942 89.408,110.942 89.408,103.789  89.915,103.789  "
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M70.184,208.308c-4.73-23.342-1.798-47.719,9.265-68.811 c10.301-19.638,29.049-39.734,63.043-44.118c77.878-10.046,81.287,113.143,170.696,58.908 c89.409-54.234,164.746,51.362,104.429,114.365c-60.318,63.003-192.039,76.824-258.019,48.093 C97.479,289.698,76.891,241.408,70.184,208.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M70.184,208.308c-4.73-23.342-1.798-47.719,9.265-68.811 c10.301-19.638,29.049-39.734,63.043-44.118c77.878-10.046,81.287,113.143,170.696,58.908 c89.409-54.234,164.746,51.362,104.429,114.365c-60.318,63.003-192.039,76.824-258.019,48.093 C97.479,289.698,76.891,241.408,70.184,208.308z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M467.736,455.762c0,2.644-97.131,4.788-216.949,4.788s-216.948-2.143-216.948-4.788 c0-2.644,97.131-4.788,216.948-4.788S467.736,453.117,467.736,455.762z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.7138 171.3872)",
    style: {
      fill: "#4a4844"
    },
    cx: 200.526,
    cy: 101.04,
    rx: 16.018,
    ry: 16.018
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.557,101.036v0.008c0,0.739-0.603,1.341-1.35,1.341h-5.34v5.34 c0,0.739-0.603,1.341-1.341,1.341c-0.747,0-1.35-0.603-1.35-1.341v-5.34h-5.34c-0.739,0-1.341-0.603-1.341-1.341v-0.008 c0-0.739,0.603-1.341,1.341-1.341h5.34v-5.34c0-0.739,0.603-1.341,1.35-1.341c0.739,0,1.341,0.603,1.341,1.341v5.34h5.34 C207.954,99.695,208.557,100.298,208.557,101.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M200.526,121.122c-0.264,0-0.478-0.214-0.478-0.478v-0.956c0-0.264,0.214-0.478,0.478-0.478 c0.264,0,0.478,0.214,0.478,0.478v0.956C201.004,120.909,200.79,121.122,200.526,121.122z M201.004,143.567v-1.91 c0-0.264-0.214-0.478-0.478-0.478c-0.264,0-0.478,0.214-0.478,0.478v1.91c0,0.264,0.214,0.478,0.478,0.478 C200.79,144.045,201.004,143.831,201.004,143.567z M201.004,137.836v-1.91c0-0.264-0.214-0.478-0.478-0.478 c-0.264,0-0.478,0.214-0.478,0.478v1.91c0,0.264,0.214,0.478,0.478,0.478C200.79,138.314,201.004,138.1,201.004,137.836z  M201.004,132.105v-1.91c0-0.264-0.214-0.478-0.478-0.478c-0.264,0-0.478,0.214-0.478,0.478v1.91c0,0.264,0.214,0.478,0.478,0.478 C200.79,132.583,201.004,132.37,201.004,132.105z M201.004,126.375v-1.91c0-0.264-0.214-0.478-0.478-0.478 c-0.264,0-0.478,0.214-0.478,0.478v1.91c0,0.264,0.214,0.478,0.478,0.478C200.79,126.853,201.004,126.639,201.004,126.375z  M201.96,148.343c0-0.264-0.214-0.478-0.478-0.478h-0.478v-0.478c0-0.264-0.214-0.478-0.478-0.478 c-0.264,0-0.478,0.214-0.478,0.478v0.956c0,0.264,0.214,0.478,0.478,0.478h0.956C201.746,148.821,201.96,148.607,201.96,148.343z  M223.682,148.343c0-0.264-0.214-0.478-0.478-0.478h-1.81c-0.264,0-0.478,0.214-0.478,0.478s0.214,0.478,0.478,0.478h1.81 C223.468,148.821,223.682,148.607,223.682,148.343z M218.251,148.343c0-0.264-0.214-0.478-0.478-0.478h-1.81 c-0.264,0-0.478,0.214-0.478,0.478s0.214,0.478,0.478,0.478h1.81C218.037,148.821,218.251,148.607,218.251,148.343z  M212.821,148.343c0-0.264-0.214-0.478-0.478-0.478h-1.81c-0.264,0-0.478,0.214-0.478,0.478s0.214,0.478,0.478,0.478h1.81 C212.607,148.821,212.821,148.607,212.821,148.343z M207.391,148.343c0-0.264-0.214-0.478-0.478-0.478h-1.81 c-0.264,0-0.478,0.214-0.478,0.478s0.214,0.478,0.478,0.478h1.81C207.177,148.821,207.391,148.607,207.391,148.343z  M228.258,148.343c0-0.264-0.214-0.478-0.478-0.478h-0.956c-0.264,0-0.478,0.214-0.478,0.478s0.214,0.478,0.478,0.478h0.956 C228.044,148.821,228.258,148.607,228.258,148.343z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "408.41,431.996 409.415,448.067 402.564,448.613 397.962,432.809  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M404.159,447.012c0,0-1.05-1.298-2.382-0.855c-1.332,0.443-3.075,2.624-3.075,2.624 s-7.224,2.317-9.174,2.439c-1.951,0.122-3.234,1.374-3.393,4.999h24.566c0,0,0-8.522-0.833-9.999 c-0.723-1.28-2.173,0.366-2.173,0.366L404.159,447.012z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M386.695,455.098c1.418-0.017,2.843-0.033,4.261-0.049c6.211-0.066,12.43-0.131,18.641-0.189 c0.238-0.008,0.238-0.369,0-0.369c-0.418,0.008-0.844,0.008-1.262,0.008c0-0.016,0-0.025-0.008-0.041 c-0.901-1.975,0.139-3.99,1.917-4.998c0.205-0.115,0.025-0.434-0.18-0.311c-1.934,1.09-2.991,3.245-2.106,5.359l-2.63,0.025 c-6.211,0.065-12.422,0.131-18.633,0.197C386.457,454.729,386.457,455.098,386.695,455.098z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M399.54,450.267c-0.823-1.156-2.212-1.484-3.379-0.612c-0.189,0.141-0.371-0.177-0.185-0.316 c1.339-1.001,2.948-0.566,3.88,0.743C399.992,450.275,399.675,450.458,399.54,450.267L399.54,450.267z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.502,450.882c-0.823-1.156-2.213-1.484-3.379-0.612c-0.189,0.141-0.371-0.177-0.185-0.316 c1.339-1.001,2.948-0.566,3.88,0.743C397.955,450.89,397.637,451.073,397.502,450.882L397.502,450.882z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.397,451.497c-0.823-1.156-2.212-1.484-3.379-0.612c-0.189,0.141-0.371-0.176-0.185-0.316 c1.339-1.001,2.948-0.566,3.88,0.743C395.85,451.505,395.533,451.688,395.397,451.497L395.397,451.497z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "355.88,431.827 354.925,448.062 348.007,448.613 345.332,432.648  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M349.602,447.012c0,0-1.05-1.298-2.382-0.855c-1.332,0.443-3.075,2.624-3.075,2.624 s-7.224,2.317-9.175,2.439c-1.951,0.122-3.658,1.219-4.39,4.999h23.655c0,0,0.931-8.535,1.075-9.999 c0.144-1.463-2.172,0.366-2.172,0.366L349.602,447.012z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.283,455.098c1.418-0.017,2.843-0.033,4.261-0.049c6.211-0.066,12.43-0.131,18.641-0.189 c0.238-0.008,0.238-0.369,0-0.369c-0.418,0.008-0.844,0.008-1.262,0.008c0-0.016,0-0.025-0.008-0.041 c-0.901-1.975,0.139-3.99,1.917-4.998c0.205-0.115,0.025-0.434-0.18-0.311c-1.934,1.09-2.991,3.245-2.106,5.359l-2.63,0.025 c-6.211,0.065-12.422,0.131-18.633,0.197C331.045,454.729,331.045,455.098,331.283,455.098z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.983,450.267c-0.823-1.156-2.213-1.484-3.38-0.612c-0.189,0.141-0.371-0.177-0.185-0.316 c1.339-1.001,2.948-0.566,3.88,0.743C345.436,450.275,345.118,450.458,344.983,450.267L344.983,450.267z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.945,450.882c-0.823-1.156-2.213-1.484-3.379-0.612c-0.189,0.141-0.371-0.177-0.185-0.316 c1.339-1.001,2.948-0.566,3.88,0.743C343.398,450.89,343.081,451.073,342.945,450.882L342.945,450.882z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.84,451.497c-0.823-1.156-2.213-1.484-3.38-0.612c-0.189,0.141-0.371-0.176-0.185-0.316 c1.339-1.001,2.948-0.566,3.88,0.743C341.293,451.505,340.976,451.688,340.84,451.497L340.84,451.497z"
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M339.762,262.658c0,0-4.039,54.253-3.773,78.081c0.276,24.785,8.36,96.907,8.36,96.907h13.237 c0,0,2.44-70.856,3.625-95.197c1.292-26.536,9.221-84.141,9.221-84.141L339.762,262.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M363.736,312.926c1.033-9.735,2.229-19.795,3.313-28.588l-1.55-9.28 C365.499,275.058,360.312,289.545,363.736,312.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M358.583,433.642c-0.027,1.43-0.131,4.274-0.131,4.274h-15.257l-0.459-4.274H358.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M362.348,258.308c0,0,4.018,59.756,8.338,82.127c4.73,24.498,26.2,97.211,26.2,97.211h14.311 c0,0-9.192-70.545-11.639-94.801c-2.656-26.325-3.811-79.482-3.811-79.482L362.348,258.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M411.837,433.536c0.139,1.465,0.361,4.379,0.361,4.379h-16.76l-1.009-4.379H411.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M398.184,268.45c-28.61,1.95-50.12,2.1-61.52-2.2c-0.79-50.38,0.97-81.72,3.34-89.38 c0.64-2.06,2.04-3.78,3.96-4.76c1.97-1.02,4.98-2.2,9.02-2.8c5.99-0.89,15.91-1.15,22.78-1.13c3.77,0.01,7.64,0.3,10.83,0.62 c3.96,0.41,6.55,3.95,6.38,7.93c-0.34,7.66-0.37,15.41-0.19,23.01c0.11,4.38,0.28,8.7,0.5,12.93 C394.714,239.68,398.134,262.56,398.184,268.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M393.284,212.67l-12.288-27.007l11.788,14.077C392.894,204.12,393.064,208.44,393.284,212.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.122,128.963c-1.511-1.641-6.58-1.78-8.995,1.38c-2.577,3.373-5.849,9.621-7.928,7.966 c0,0,0.857,3.095,4.39,3.334c0,0-2.112,2.307-4.828,1.455c0,0,1.211,4.266,6.284,5.006c4.658,0.679,11.134-12.653,12.163-14.839 C358.203,130.855,358.019,130.947,357.122,128.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M360.017,129.549c4.134-0.458,8.333,0.708,11.484,3.423c2.058,1.773,3.655,4.122,2.946,6.915 c-1.656,6.518-6.055,17.038-6.055,17.038l-19.746-15.183c0,0-0.1-6.331,3.078-9.473 C353.377,130.634,356.961,129.889,360.017,129.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.389,129.193c0,0,6.801-4.852,15.848,1.875c9.047,6.727-0.038,18.916-0.038,18.916 s-2.897,5.39-0.341,6.712c0,0-1.618,0.636-2.82,0.497c0,0,0.877,1.633,2.001,1.492c0,0-1.564,0.629-4.348-0.617 C363.907,156.823,356.389,129.193,356.389,129.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M356.823,162.794l-0.003,0.009c0.009,0.032,0.013,0.052,0.022,0.083l0.539,3.948 c-0.013,0.791-0.099,1.569-0.252,2.317c-0.127,0.631-0.304,1.237-0.51,1.816c-0.983,1.048-1.704,3.613,1.281,3.994 c3.767,0.488,11.365-4.167,11.819-5.799c-1.108-5.368-1.824-11.573-0.934-16.461l-4.877,4.122L356.823,162.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M356.842,162.887l0.539,3.948c2.492-0.785,5.247-2.802,6.122-5.242 c0.619-1.763,0.012-3.559-0.708-3.742L356.842,162.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M348.287,153.701c0.12,0.859,0.268,1.709,0.436,2.55c1.499,7.425,10.217,9.157,16.338,4.579 c0.01-0.009,0.01-0.019,0.019-0.019c0.543-0.407,1.067-0.861,1.564-1.373c4.042-4.146,3.603-7.769,4.063-15.818 c0.46-8.039-7.455-14.074-15.196-10.884C348.367,135.68,347.068,145.111,348.287,153.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.925,147.152c0.009,0.649-0.327,1.179-0.751,1.185c-0.424,0.006-0.775-0.515-0.784-1.164 c-0.009-0.649,0.327-1.179,0.751-1.185C357.565,145.982,357.916,146.503,357.925,147.152"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.859,147.222c0.009,0.649-0.327,1.179-0.751,1.185c-0.424,0.006-0.775-0.515-0.784-1.164 c-0.009-0.649,0.328-1.179,0.751-1.185C350.499,146.052,350.85,146.573,350.859,147.222"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.366,155.993c-0.137-0.016-0.217-0.031-0.222-0.033c-0.134-0.029-0.219-0.16-0.191-0.294 c0.029-0.133,0.159-0.217,0.294-0.191c0.131,0.028,3.341,0.662,4.242-2.96c0.032-0.133,0.171-0.217,0.3-0.181 c0.134,0.033,0.214,0.168,0.181,0.301C359.098,156.15,356.195,156.086,355.366,155.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M370.702,144.376c0,0-2,1.492-2.418,3.53c-0.125,0.609-0.545,0.678-0.545,0.678l-2.917,0.237 c0,0,1.779-7.759-0.305-7.921c-2.084-0.162,0.606-3.413-0.574-4.08c-2.785-1.575-10.78-2.656-14.473,1.775 c0,0,1.415-4.652,5.536-6.737c4.121-2.085,11.831-1.662,14.448,2.48C372.071,138.481,370.702,144.376,370.702,144.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M374.183,148.971c-0.584,2.092-2.079,3.72-3.647,4.572c-2.36,1.281-4.136-0.685-3.98-3.224 c0.141-2.286,1.538-5.707,4.147-5.942C373.272,144.144,374.85,146.579,374.183,148.971"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.927,144.533c0.112-0.001,0.219-0.06,0.277-0.164c0.26-0.467,0.593-0.758,0.989-0.866 c0.652-0.177,1.294,0.187,1.301,0.192c0.148,0.089,0.348,0.041,0.437-0.113c0.09-0.152,0.039-0.348-0.113-0.438 c-0.034-0.02-0.875-0.507-1.793-0.258c-0.569,0.154-1.034,0.549-1.38,1.172c-0.086,0.154-0.031,0.349,0.124,0.435 C348.819,144.52,348.873,144.533,348.927,144.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M361.196,144.277c0.047-0.003,0.094-0.017,0.137-0.042c0.152-0.088,0.206-0.282,0.118-0.435 c-0.02-0.036-0.509-0.874-1.43-1.112c-0.571-0.148-1.17-0.035-1.779,0.335c-0.152,0.092-0.2,0.288-0.108,0.439 c0.092,0.152,0.289,0.199,0.439,0.107c0.455-0.276,0.887-0.365,1.283-0.264c0.658,0.168,1.037,0.806,1.04,0.813 C360.96,144.227,361.078,144.285,361.196,144.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M354.049,146.599c0,0-0.465,2.072-2.1,3.461c-1.636,1.389,1.607,2.6,1.607,2.6L354.049,146.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M367.975,145.934c-4.082-0.411-6.625,1.044-7.263,1.464c-0.191-1.782-1.353-3.162-2.767-3.162 c-1.492,0-2.705,1.536-2.789,3.462c-1.462-0.865-2.472-0.352-2.876-0.048c-0.103-1.903-1.306-3.414-2.787-3.414 c-1.547,0-2.806,1.646-2.806,3.671c0,2.023,1.259,3.67,2.806,3.67c1.533,0,2.779-1.617,2.802-3.614 c0.133-0.134,1.152-1.057,2.85,0.021c0.032,1.987,1.273,3.592,2.8,3.592c1.548,0,2.807-1.646,2.807-3.67 c0-0.076-0.014-0.147-0.017-0.222c0.292-0.213,2.841-1.953,7.215-1.502c0.067,0.011,0.131-0.043,0.137-0.112 C368.094,146.002,368.043,145.941,367.975,145.934z M349.493,151.326c-1.409,0-2.556-1.534-2.556-3.42 c0-1.886,1.147-3.421,2.556-3.421c1.41,0,2.557,1.534,2.557,3.421C352.049,149.792,350.903,151.326,349.493,151.326z  M357.945,151.326c-1.409,0-2.556-1.534-2.556-3.42c0-1.886,1.146-3.421,2.556-3.421c1.41,0,2.557,1.534,2.557,3.421 C360.501,149.792,359.355,151.326,357.945,151.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M339.494,178.88l-8.58,20.54c-1.44,3.4-2.91,6.78-4.4,10.09c-0.74,1.65-1.51,3.28-2.28,4.85 c-0.77,1.57-1.56,3.11-2.31,4.37c-0.23,0.41-0.5,0.81-0.66,1.03l-0.01,0.01l-1.11,0.53l-1.22,0.55l-2.5,1.09l-10.29,4.36 c-6.91,2.93-13.83,5.95-20.68,9.14l2.42,7.54c7.47-1.42,14.85-3.09,22.21-4.96c3.67-0.97,7.34-1.92,11.03-3.03l2.8-0.85l1.42-0.45 l1.51-0.52l0.57-0.21l0.26-0.11l1.03-0.45c0.19-0.09,0.32-0.14,0.54-0.25c0.22-0.13,0.43-0.25,0.63-0.39 c0.21-0.13,0.42-0.28,0.54-0.37c0.61-0.47,1.01-0.84,1.37-1.2c0.45-0.46,0.82-0.88,1.14-1.27c0.61-0.73,1.05-1.36,1.5-1.99 c0.76-1.1,1.42-2.16,2.04-3.19c0.46-0.75,0.88-1.48,1.3-2.21c0.98-1.76,1.9-3.5,2.79-5.23c1.79-3.47,3.42-6.95,5.02-10.43 c3.17-6.98,6.12-13.94,8.81-21.13L339.494,178.88z M321.724,219.54l-0.06,0.04l-0.04,0.02l0.1-0.07c0.03-0.02,0.06-0.04,0.09-0.05 C321.784,219.5,321.754,219.52,321.724,219.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M338.724,191.45c-0.83,5.95-2.25,32.22-2.25,32.22s0,0.02-0.01,0.07c-0.62,1.03-1.28,2.09-2.04,3.19 c-0.45,0.63-0.89,1.26-1.5,1.99C333.474,216.31,338.724,191.45,338.724,191.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M288.494,240.606c-0.395-2.539-1.152-4.328-1.152-4.328s-2.071-2.216-4.578-2.271 c-2.507-0.056-4.494-0.767-6.361-0.68c-1.867,0.088,0.117,1.645,1.34,2.26c1.223,0.615,2.603,1.325,1.993,2.169 c-0.611,0.844-8.777,4.529-9.49,5.795c-0.714,1.266,0.794,1.084,0.794,1.084s-1.825,0.84-1.795,1.827 c0.03,0.987,1.335,0.804,1.335,0.804s-1.206,0.607-0.68,1.408c0.276,0.421,2.351,0.088,4.311-0.309 c-0.405,0.193-0.692,0.433-0.737,0.732c-0.185,1.221,2.515,0.82,4.675,0.545c2.16-0.275,4.356-1.254,5.858-2.894 C285.507,245.108,288.888,243.145,288.494,240.606z M277.644,247.646c0.088-0.013,0.156-0.019,0.182-0.013 C277.825,247.633,277.759,247.637,277.644,247.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M270.927,247.332c2.091-0.946,4.211-1.822,6.346-2.613c0.224,0.557,0.491,1.084,0.793,1.605 c0.158,0.253,0.48-0.075,0.336-0.328c-0.92-1.561-1.481-3.345-1.669-5.266c-0.031-0.311-0.44-0.208-0.409,0.103 c0.047,0.48,0.115,0.939,0.211,1.398c-0.036-0.021-0.078-0.021-0.12-0.006c-1.714,0.49-3.369,1.192-4.965,2.105 c-0.239,0.144-0.079,0.581,0.174,0.437c1.561-0.892,3.181-1.586,4.853-2.061c0.063-0.022,0.105-0.065,0.133-0.121 c0.126,0.586,0.294,1.157,0.497,1.707c-2.135,0.791-4.248,1.66-6.346,2.613C270.507,247.018,270.673,247.447,270.927,247.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M278.938,242.494c1.62-2.193,4.066-3.016,6.329-2.181c0.255,0.097,0.414-0.365,0.158-0.461 c-2.455-0.91-5.07,0.013-6.823,2.37C278.428,242.471,278.763,242.729,278.938,242.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M391.615,171.837c4.881,6.35,9.555,12.833,14.169,19.378c2.312,3.268,4.588,6.565,6.845,9.885 c2.285,3.33,4.466,6.622,6.745,10.171l0.435,0.682l0.53,0.87l0.262,0.436l0.065,0.109l0.234,0.435l0.246,0.517 c0.081,0.18,0.154,0.361,0.183,0.448c0.165,0.449,0.313,0.947,0.37,1.217l0.109,0.486l0.067,0.383 c0.163,0.999,0.19,1.7,0.217,2.376c0.017,0.656,0.018,1.274,0.004,1.854c-0.057,2.325-0.236,4.408-0.432,6.496 c-0.417,4.149-0.988,8.171-1.608,12.183c-1.246,8.016-2.816,15.905-4.665,23.798l-8.388-1.001 c0.001-7.976,0.091-15.98,0.204-23.882c0.048-3.948,0.073-7.894,0.012-11.726c-0.028-1.901-0.084-3.814-0.234-5.482 c-0.036-0.419-0.084-0.798-0.133-1.138c-0.048-0.32-0.121-0.614-0.139-0.597c-0.002,0.005-0.003,0.015-0.003,0.015l0.019,0.122 c0.004,0.026,0.066,0.289,0.15,0.502l0.11,0.276c0.05,0.118,0.105,0.235,0.165,0.349l0.149,0.268l-0.036-0.048l-0.145-0.193 l-0.694-0.941c-2.253-3.029-4.753-6.211-7.132-9.366c-2.419-3.157-4.837-6.324-7.228-9.512 c-4.795-6.367-9.561-12.773-14.144-19.296L391.615,171.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M415.222,263.055c-1.828-4.747-5.919-3.535-7.12-2.33c0,0-3.039,3.074-3.655,4.836 c-0.616,1.761-1.519,3.481-1.204,4.284c0.146,0.373,0.675-0.022,1.201-0.549c-0.316,0.923-0.515,1.672-0.485,2.039 c0,0,0.46,4.857,2.351,6.374c1.891,1.517,1.533-2.849,1.533-2.849s0.227,4.327,4.801,2.932c1.753-0.534,3.698-5.723,4.009-8.617 C417.449,266.714,415.222,263.055,415.222,263.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M357.463,167.625c0,0-3.898-0.428-5.976,1.943c-0.833,2.91,1.003,6.375,2.988,9.87l4.312-4.452 C359.077,174.988,356.845,171.193,357.463,167.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M357.463,167.625c0,0-3.898-0.428-5.976,1.943c-0.833,2.91,1.003,6.375,2.988,9.87l4.312-4.452 C359.077,174.988,356.845,171.193,357.463,167.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M369.053,165.497c-1.847,4.256-5.784,7.062-10.266,9.489l2.435,4.452l15.027-11.257 C376.249,168.18,371.917,164.363,369.053,165.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M369.053,165.497c-1.847,4.256-5.784,7.062-10.266,9.489l2.435,4.452l15.027-11.257 C376.249,168.18,371.917,164.363,369.053,165.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M358.814,181.408c0,0.424-0.343,0.767-0.767,0.767s-0.767-0.343-0.767-0.767 c0-0.423,0.343-0.767,0.767-0.767S358.814,180.985,358.814,181.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M358.814,186.429c0,0.423-0.343,0.767-0.767,0.767s-0.767-0.343-0.767-0.767 c0-0.423,0.343-0.767,0.767-0.767S358.814,186.006,358.814,186.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M358.814,191.45c0,0.424-0.343,0.767-0.767,0.767s-0.767-0.343-0.767-0.767 c0-0.423,0.343-0.767,0.767-0.767S358.814,191.027,358.814,191.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "263.085,438.04 265.136,448.416 270.622,448.416 271.353,438.04  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M269.899,447.099c0,0,1.04-1.285,2.36-0.846c1.319,0.439,3.046,2.599,3.046,2.599 s7.155,2.295,9.087,2.416c1.932,0.121,3.623,1.208,4.348,4.952h-23.431c0,0-0.922-8.454-1.065-9.904 c-0.143-1.449,2.152,0.362,2.152,0.362L269.899,447.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M288.044,455.103c-1.409-0.014-2.811-0.028-4.22-0.042c-6.154-0.062-12.309-0.131-18.463-0.193 c-0.235,0-0.235-0.366,0-0.359c0.414,0.007,0.836,0.007,1.25,0.014c0-0.014,0.007-0.035,0.014-0.048 c0.884-1.955-0.138-3.951-1.906-4.953c-0.207-0.111-0.021-0.428,0.18-0.311c1.913,1.085,2.963,3.219,2.086,5.312 c0.87,0.014,1.734,0.021,2.604,0.027c6.147,0.062,12.302,0.131,18.456,0.193C288.279,454.744,288.279,455.11,288.044,455.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.474,450.324c0.815-1.145,2.192-1.47,3.348-0.606c0.187,0.14,0.368-0.175,0.183-0.313 c-1.327-0.991-2.921-0.561-3.843,0.736C274.026,450.331,274.34,450.512,274.474,450.324L274.474,450.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.493,450.933c0.815-1.145,2.192-1.47,3.347-0.607c0.187,0.14,0.368-0.175,0.183-0.313 c-1.327-0.991-2.921-0.561-3.843,0.736C276.045,450.94,276.359,451.122,276.493,450.933L276.493,450.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.578,451.542c0.815-1.145,2.191-1.47,3.347-0.607c0.187,0.14,0.368-0.175,0.183-0.313 c-1.327-0.991-2.921-0.561-3.843,0.737C278.129,451.55,278.443,451.731,278.578,451.542L278.578,451.542z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "214.007,438.114 215.145,448.416 220.631,448.416 222.274,438.114  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M219.908,447.099c0,0,1.04-1.285,2.359-0.846c1.319,0.439,3.046,2.599,3.046,2.599 s7.155,2.295,9.087,2.416c1.932,0.121,3.623,1.208,4.348,4.952h-23.431c0,0-0.922-8.454-1.065-9.904 c-0.143-1.449,2.152,0.362,2.152,0.362L219.908,447.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M238.053,455.103c-1.409-0.014-2.811-0.028-4.22-0.042c-6.154-0.062-12.309-0.131-18.463-0.193 c-0.235,0-0.235-0.366,0-0.359c0.414,0.007,0.836,0.007,1.25,0.014c0-0.014,0.007-0.035,0.014-0.048 c0.884-1.955-0.138-3.951-1.906-4.953c-0.207-0.111-0.021-0.428,0.18-0.311c1.913,1.085,2.963,3.219,2.086,5.312 c0.87,0.014,1.734,0.021,2.604,0.027c6.148,0.062,12.302,0.131,18.456,0.193C238.288,454.744,238.288,455.11,238.053,455.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.484,450.324c0.815-1.145,2.192-1.47,3.348-0.606c0.187,0.14,0.368-0.175,0.183-0.313 c-1.327-0.991-2.921-0.561-3.843,0.736C224.035,450.331,224.349,450.512,224.484,450.324L224.484,450.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.502,450.933c0.815-1.145,2.192-1.47,3.348-0.607c0.187,0.14,0.368-0.175,0.183-0.313 c-1.327-0.991-2.921-0.561-3.843,0.736C226.054,450.94,226.368,451.122,226.502,450.933L226.502,450.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.587,451.542c0.815-1.145,2.192-1.47,3.347-0.607c0.187,0.14,0.368-0.175,0.183-0.313 c-1.327-0.991-2.921-0.561-3.844,0.737C228.139,451.55,228.453,451.731,228.587,451.542L228.587,451.542z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M261.26,438.405h12.105c1.047-15.588,4.011-67.241,1.669-92.801 c1.684-35.465-3.736-82.542-3.736-82.542h-38.347c0,0,2.81,31.503,15.423,82.031C248.288,385.125,258.059,425.145,261.26,438.405z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M261.26,438.405h12.105c1.047-15.588,4.011-67.241,1.669-92.801 c1.684-35.465-3.736-82.542-3.736-82.542h-38.347c0,0,2.81,31.503,15.423,82.031C248.288,385.125,258.059,425.145,261.26,438.405z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M246.307,336.601c6.932-28.315,0.845-65.032,0.845-65.032l-5.982,41.94L246.307,336.601z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "259.818,438.101 260.706,442.702 274.587,442.642 274.595,438.04  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M212.281,438.852h12.105c4.313-16.036,12.977-67.595,14.363-93.155 c6.857-35.465,10.138-82.635,10.138-82.635H210.54c0,0-3.567,31.864,1.677,82.392 C211.198,389.506,212.006,425.145,212.281,438.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M212.281,438.852h12.105c4.313-16.036,12.977-67.595,14.363-93.155 c6.857-35.465,10.138-82.635,10.138-82.635H210.54c0,0-3.567,31.864,1.677,82.392 C211.198,389.506,212.006,425.145,212.281,438.852z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "211.223,438.089 211.198,442.65 225.189,442.652 225.922,438.092  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M276.314,268.85c-26.6,10.22-69.93,2.81-69.93,2.81c0.29-7.29,0.56-18.57,0.71-30.86 c0.04-3.3,0.07-6.67,0.09-10.06c0.04-6.5,0.04-13.06-0.01-19.25c-0.01-0.5-0.01-1-0.02-1.49c-0.03-3.04-0.08-5.98-0.14-8.76 c-0.01-0.34-0.01-0.68-0.02-1.02c-0.12-5.47-0.32-10.31-0.57-14.18c-0.49-7.29,3.48-14.08,10.69-15.29 c2.19-0.37,4.56-0.7,7.02-0.96c0.58-0.07,1.18-0.12,1.78-0.18c6.83-0.67,14.33-0.97,21.17-0.77c0.34,0,0.69,0.01,1.03,0.02 c0.17,0.01,0.37,0.01,0.54,0.02c0.29,0.01,0.6,0.02,0.89,0.04c3.04,0.12,5.94,0.35,8.53,0.69c5.88,0.76,11.1,5.4,11.2,11.34 c0.09,5.44,0.62,16.93,1.39,29.89c0.3,4.9,0.63,10.03,0.99,15.11C273.044,245.96,274.814,265.35,276.314,268.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M221.964,191.45c0,0-0.575,28.245,1.304,31.675s38.207,13.799,38.207,13.799 c-18.184-2.472-35.774-5.242-45.082-12.174L221.964,191.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M262.724,245.22c-21.17,5.01-45.93-1.42-55.63-4.42c0.04-3.3,0.07-6.67,0.09-10.06 C222.094,241.77,262.724,245.22,262.724,245.22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4a4844"
    },
    points: "244.731,186.124 241.164,225.667 248.296,240.031 253.867,224.333 248.102,186.124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4a4844"
    },
    points: "245.581,177.618 241.73,183.328 246.256,188.563 250.782,181.824  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M253.406,130.225c-4.157-1.477-8.776-1.291-12.689,0.747c-2.555,1.331-4.775,3.369-4.72,6.425 c0.128,7.132,2.116,19.063,2.116,19.063l24.075-10.884c0,0,1.753-5.974-1.066-9.785 C259.028,132.962,256.479,131.317,253.406,130.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M244.417,129.629c0,0-3.253-1.813-6.522,1.562c-2.725,2.813-1.534,11.971-1.534,11.971 L244.417,129.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M242.001,130.383c0,0,0.938-5.442,10.871-3.817c9.934,1.625,17.809,9.829,14.184,14.125 c-3.49,4.136-14.184-2.75-14.184-2.75L242.001,130.383z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M248.634,165.327l0.001,0.01c-0.017,0.031-0.026,0.05-0.043,0.081l-1.515,3.946 c-0.178,0.82-0.278,1.644-0.302,2.453c-0.022,0.683,0.013,1.352,0.086,1.999c0.76,1.321,0.883,4.144-2.292,3.813 c-4.008-0.411-10.803-6.699-10.875-8.494c2.447-5.274,4.773-11.869,5.041-17.133l4.035,5.44L248.634,165.327z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M245.581,177.618c0.948-2.094,0.938-4.618,1.272-6.879c0,0,0.175-1.682,0.663-2.518 c0,0,2.745-0.639,4.351,0.812c0.641,4.383,0.131,8.729-1.16,13.05L245.581,177.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230.378,169.229c0,0,2.222-4.271,5.266-4.792c0.37,5.157,2.465,9.244,9.937,13.18l-4.417,6.549 C235.019,179.145,231.562,174.168,230.378,169.229z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.591,165.418l-1.515,3.946c-2.382-1.416-4.738-4.167-5.048-6.899c-0.211-1.971,0.852-3.677,1.639-3.691 L248.591,165.418z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M259.656,158.01c-0.332,0.858-0.692,1.699-1.069,2.527c-3.35,7.303-12.773,6.975-17.981,0.762 c-0.007-0.012-0.005-0.022-0.015-0.024c-0.461-0.552-0.893-1.148-1.282-1.797c-3.168-5.262-1.834-8.897-0.355-17.319 c1.476-8.412,11.114-12.723,18.332-7.55C263.947,139.383,262.999,149.436,259.656,158.01z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.806,145.403c0,0-0.042,7.028,2.708,8.028s4.795-1.333,7.814,1.583c0,0,1.98-1.043,3.808,0.333 c1.828,1.376,1.519,2.193,1.519,2.193s-0.696,10.484-10.294,9.27c-9.597-1.214-10.764-10.63-10.097-15.63l1.893-6.21 L243.806,145.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250.049,155.207c0,0,2.51,0.907,5.951,1.711c0,0-1.213,2.816-4.256,1.51 C249.806,157.595,250.049,155.207,250.049,155.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M258.02,133.826c-3.749-3.153-11.813-4.588-15.521-0.946c-3.708,3.642-3.726,10.062-3.726,10.062 s-0.1,1.161,0.617,1.926c0.07,0.067,0.152,0.187,0.241,0.324l4.173,0.681c0.333-1.719,1.026-4.855,2.199-5.019 c2.196-0.308,0.7-2.728,1.172-4.087c1.532-4.415,13.544-1.396,14.925,5.359C262.101,142.126,261.769,136.979,258.02,133.826z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M234.065,146.84c0.095,2.302,1.243,4.346,2.656,5.606c2.126,1.896,4.437,0.297,4.892-2.363 c0.41-2.394-0.203-6.266-2.839-7.142C236.176,142.077,233.957,144.208,234.065,146.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.27,147.335c-0.155,0.645,0.062,1.25,0.483,1.351c0.421,0.101,0.889-0.34,1.043-0.985 c0.155-0.645-0.061-1.25-0.483-1.351C251.892,146.249,251.424,146.69,251.27,147.335"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M258.089,148.945c-0.155,0.645,0.061,1.25,0.483,1.351c0.422,0.101,0.889-0.339,1.043-0.984 c0.155-0.645-0.062-1.25-0.483-1.351C258.711,147.859,258.243,148.3,258.089,148.945"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M261.023,146.987c-0.115-0.028-0.212-0.115-0.246-0.237c-0.155-0.545-0.428-0.926-0.811-1.134 c-0.631-0.341-1.382-0.121-1.39-0.118c-0.174,0.056-0.369-0.042-0.424-0.223c-0.056-0.179,0.044-0.369,0.223-0.425 c0.04-0.013,1.027-0.311,1.914,0.169c0.55,0.298,0.934,0.818,1.141,1.545c0.052,0.18-0.053,0.368-0.233,0.419 C261.137,147,261.078,147,261.023,146.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M249.875,144.331c-0.053-0.013-0.103-0.038-0.148-0.075c-0.156-0.129-0.178-0.36-0.049-0.516 c0.03-0.036,0.747-0.891,1.837-0.983c0.676-0.056,1.333,0.187,1.952,0.726c0.154,0.134,0.171,0.366,0.037,0.519 c-0.134,0.154-0.366,0.169-0.519,0.036c-0.462-0.401-0.934-0.586-1.403-0.549c-0.779,0.062-1.331,0.712-1.337,0.719 C250.152,144.321,250.007,144.363,249.875,144.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED847E"
    },
    d: "M255.755,147.505c0,0,0.339,2.997,1.25,5.073c0.914,2.084-2.677,1.305-2.677,1.305 L255.755,147.505z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M282.702,243.369c-1.339-2.318-6.235-4.439-6.235-4.439c-0.64-0.224-2.25-0.212-4.011-0.111 l0.192-0.018c0,0,3.205-1.837,2.398-2.283c-0.807-0.446-2.757,0.271-4.711,0.679c-1.954,0.408-4.15,2.206-4.15,2.206 c-1.43,0.866-2.256,3.558-1.246,7.114c0,0,4.085,3.887,6.99,4.422c2.867,0.704,8.727,1.06,10.031-0.732 c2.736-3.758-2.315-6.401-2.315-6.401S284.041,245.688,282.702,243.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M264.604,237.71l-1.14,7.83c-8.31-0.45-16.51-1.2-24.76-2.3c-4.13-0.54-8.25-1.2-12.42-1.98 c-2.09-0.39-4.18-0.84-6.32-1.37c-2.14-0.54-4.28-1.11-6.7-2.05c-0.61-0.24-1.25-0.51-1.95-0.85c-0.7-0.36-1.44-0.76-2.41-1.5 c-0.49-0.38-1.04-0.84-1.7-1.62c-0.32-0.38-0.69-0.9-1.03-1.53c-0.18-0.36-0.34-0.68-0.5-1.12c-0.07-0.22-0.14-0.44-0.21-0.66 l-0.05-0.22c-0.3-1.21-0.37-1.92-0.46-2.63c-0.28-2.63-0.33-4.72-0.38-6.9c-0.04-4.29,0.03-8.44,0.19-12.6 c0.28-8.31,0.88-16.49,1.72-24.74l15.94,1.39c-0.23,4.02-0.6,8.09-0.86,12.13l-0.94,12.11c-0.3,4.02-0.63,8.04-0.8,11.94 c-0.07,1.37-0.13,2.78-0.14,4c1.22,0.57,2.69,1.13,4.16,1.64c1.8,0.62,3.67,1.2,5.56,1.78c3.78,1.15,7.67,2.19,11.57,3.23 C248.784,233.73,256.724,235.73,264.604,237.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M334.834,185.54c-5.37,5.07-10.95,9.83-16.72,14.42c-2.87,2.32-5.83,4.53-8.88,6.76 c-1.55,1.08-3.11,2.16-4.88,3.25c-0.45,0.27-0.91,0.54-1.42,0.82c-0.52,0.29-1.06,0.58-1.86,0.91c-0.43,0.16-0.87,0.35-1.81,0.56 l-0.41,0.07c-0.14,0.02-0.36,0.05-0.54,0.06c-0.4,0.03-0.91,0.06-1.72-0.04l-0.29-0.05l-0.41-0.08c-0.26-0.06-0.53-0.14-0.78-0.23 l-0.14-0.04l-0.28-0.1c-0.34-0.13-0.79-0.29-1.05-0.41l-0.86-0.38c-2.13-0.99-3.79-1.93-5.49-2.9c-1.68-0.98-3.3-1.94-4.88-2.96 c-3.16-2.02-6.26-4.05-9.28-6.17c-0.16-0.11-0.32-0.22-0.48-0.33c-0.94-0.66-1.87-1.32-2.79-1.98c-4.91-3.5-9.68-7.11-14.36-10.95 l9.78-12.66c5.83,4.16,11.6,8.55,17.31,12.87c2.87,2.13,5.7,4.32,8.55,6.39c1.43,1.03,2.83,2.08,4.22,3.06 c1,0.7,2.04,1.41,2.96,1.99c1.27-0.59,2.62-1.29,3.97-1.99c3.13-1.59,6.27-3.35,9.45-5.06c6.34-3.45,12.75-6.95,19.27-10.24 L334.834,185.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M272.654,198.7c-0.94-0.66-1.87-1.32-2.79-1.98l-0.85-13.67L272.654,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M334.185,185.663c0,0,2.017-0.137,2.875-1.538c1.663-2.717,4.283-3.215,5.333-3.792 c1.05-0.576-0.154-2.365-2.818-1.793c0,0,1.143-3.71,2.062-4.608c0.919-0.898,5.764-2.819,5.672-3.516 c-0.092-0.697-3.84,0.43-6.028,1.421c-2.188,0.991-6.627,6.486-10.625,8.454C330.658,180.292,329.082,184.451,334.185,185.663z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M143.872,181.335c0.873,6.584,1.52,13.205,2.097,19.821c0.313,3.305,0.538,6.62,0.821,9.917 l0.37,4.934l0.361,4.408c-0.025,0.12,0.13,0.851,0.317,1.501c0.179,0.667,0.407,1.4,0.643,2.133 c0.471,1.475,1.017,2.986,1.547,4.514c1.064,3.065,2.241,6.139,3.366,9.246c2.296,6.193,4.628,12.441,6.794,18.739l-7.097,3.52 c-3.723-5.641-7.161-11.391-10.465-17.273c-1.67-2.934-3.242-5.923-4.816-8.968c-0.783-1.53-1.525-3.087-2.27-4.71 c-0.371-0.817-0.737-1.638-1.1-2.544c-0.364-0.918-0.722-1.776-1.101-3.281l-0.132-0.601l-0.068-0.366l-0.124-0.682l-0.23-1.31 l-0.425-2.524l-0.798-4.981c-0.48-3.315-0.99-6.615-1.408-9.926c-0.881-6.616-1.66-13.23-2.191-19.884L143.872,181.335z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.94,272.775l-19.623-23.167c-0.491-0.579-0.419-1.447,0.16-1.938l32.625-27.635 c0.579-0.491,1.447-0.419,1.938,0.16l19.624,23.167c0.491,0.579,0.419,1.447-0.161,1.938l-32.625,27.635 C139.298,273.426,138.431,273.354,137.94,272.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M137.94,272.775l-19.623-23.167c-0.491-0.579-0.419-1.447,0.16-1.938l32.625-27.635 c0.579-0.491,1.447-0.419,1.938,0.16l19.624,23.167c0.491,0.579,0.419,1.447-0.161,1.938l-32.625,27.635 C139.298,273.426,138.431,273.354,137.94,272.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.796,246.485c0,2.378-1.928,4.306-4.306,4.306c-2.378,0-4.307-1.928-4.307-4.306 c0-2.378,1.928-4.306,4.307-4.306C147.868,242.178,149.796,244.107,149.796,246.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M123.788,130.548c0,0-7.567-0.09-9.406,8.452c-1.917,8.904-2.473,5.395-6.543,9.635 c-4.07,4.24,0.378,9.987-6.637,13.182c0,0,5.845,5.686,17.229,3.451c11.384-2.234,9.792,5.873,24.481,3.731 c0,0-2.298-4.252,0.9-8.076c3.198-3.824,0.82-6.613,0.952-10.674c0.132-4.061,1.176-12.89-4.403-16.688 c-5.579-3.799-10.495-2.139-10.495-2.139S126.614,130.107,123.788,130.548z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "143.556,436.071 146.424,447.872 152.638,447.872 152.92,436.071  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M170.683,456.22c-0.337-3.845-2.026-4.993-4.111-5.124c-2.17-0.137-9.915-2.73-9.915-2.73 s-1.618-2.442-3.043-2.938c-1.426-0.496-2.805,0.957-2.805,0.957l-3.901-0.476c0,0-1.169-1.756-1.974-0.217 c-1.247,2.383-1.096,8.981-0.98,10.529H170.683z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.177,455.215c-1.618-0.007-3.228-0.015-4.846-0.022c-7.067-0.034-14.133-0.076-21.2-0.11 c-0.27,0.001-0.215-0.413,0.054-0.406c0.475,0.006,0.96,0.003,1.436,0.008c0.002-0.016,0.013-0.039,0.023-0.055 c1.311-2.215,0.437-4.466-1.445-5.588c-0.222-0.124,0.041-0.484,0.253-0.353c2.036,1.215,2.922,3.622,1.597,5.993 c0.999,0.01,1.99,0.013,2.99,0.016c7.059,0.034,14.125,0.076,21.192,0.111 C170.501,454.807,170.446,455.221,170.177,455.215z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M155.486,450.028c1.102-1.294,2.713-1.661,3.887-0.685c0.19,0.158,0.444-0.198,0.256-0.354 c-1.348-1.121-3.22-0.634-4.469,0.832C154.977,450.037,155.305,450.241,155.486,450.028L155.486,450.028z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.677,450.717c1.102-1.294,2.713-1.661,3.887-0.685c0.19,0.158,0.444-0.197,0.256-0.354 c-1.348-1.12-3.22-0.634-4.469,0.832C157.168,450.725,157.496,450.93,157.677,450.717L157.677,450.717z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.943,451.405c1.102-1.294,2.712-1.661,3.886-0.685c0.19,0.158,0.444-0.198,0.256-0.354 c-1.347-1.12-3.22-0.633-4.469,0.832C159.434,451.414,159.762,451.618,159.943,451.405L159.943,451.405z"
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M117.848,281.483c1.264,11.892,3.75,27.276,8.249,47.075c1.307,5.753,2.785,11.881,4.457,18.406 c-4.575,37.775,13.327,92.349,13.327,92.349l9.588-0.214c0,0,1.203-60.988,0.075-92.917 c-1.848-52.313-8.22-102.146-8.22-102.146l-26.116-0.103C119.208,243.932,114.698,251.796,117.848,281.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M117.848,281.483c1.264,11.892,3.75,27.276,8.249,47.075c5.496-20.923-4.446-65.577-4.446-65.577 L117.848,281.483z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "154.57,441.355 154.873,437.248 142.082,437.248 142.805,441.355  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "103.801,436.071 106.669,447.872 112.883,447.872 113.165,436.071  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "115.048,441.355 115.351,437.248 102.56,437.248 103.283,441.355  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M130.928,456.22c-0.337-3.845-2.026-4.993-4.111-5.124c-2.17-0.137-9.915-2.73-9.915-2.73 s-1.618-2.442-3.043-2.938c-1.426-0.496-2.805,0.957-2.805,0.957l-3.901-0.476c0,0-1.169-1.756-1.974-0.217 c-1.246,2.383-1.096,8.981-0.98,10.529H130.928z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.422,455.215c-1.618-0.007-3.228-0.015-4.846-0.022c-7.067-0.034-14.133-0.076-21.2-0.11 c-0.27,0.001-0.215-0.413,0.054-0.406c0.475,0.006,0.96,0.003,1.435,0.008c0.002-0.016,0.013-0.039,0.023-0.055 c1.311-2.215,0.437-4.466-1.445-5.588c-0.222-0.124,0.041-0.484,0.253-0.353c2.036,1.215,2.922,3.622,1.597,5.993 c0.999,0.01,1.991,0.013,2.99,0.016c7.059,0.034,14.125,0.076,21.192,0.111 C130.746,454.807,130.691,455.221,130.422,455.215z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.731,450.028c1.102-1.294,2.713-1.661,3.887-0.685c0.19,0.158,0.444-0.198,0.256-0.354 c-1.347-1.121-3.22-0.634-4.469,0.832C115.222,450.037,115.549,450.241,115.731,450.028L115.731,450.028z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M117.922,450.717c1.102-1.294,2.713-1.661,3.887-0.685c0.19,0.158,0.444-0.197,0.256-0.354 c-1.347-1.12-3.22-0.634-4.469,0.832C117.413,450.725,117.74,450.93,117.922,450.717L117.922,450.717z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.188,451.405c1.102-1.294,2.712-1.661,3.886-0.685c0.19,0.158,0.444-0.198,0.256-0.354 c-1.348-1.12-3.22-0.633-4.469,0.832C119.679,451.414,120.007,451.618,120.188,451.405L120.188,451.405z"
  })))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M126.841,246.047c0,0-4.884,72.213-6.479,100.917c-1.823,32.789-5.927,88.679-6.482,92.337h-9.91 c1.136,1.105-12.72-49.06-7.134-89.905c-5.235-39.067-11.606-67.671-3.393-104.454L126.841,246.047z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M90.464,247.791c20.827,6.878,55.827,4.617,55.827-0.15c0-13.435-4.757-28.54-3.482-37.293 c9.846-6.889,2.153-13.113,3.01-23.323c0.664-7.789-4.853-14.774-12.556-16.102c-1.778-0.3-3.621-0.6-5.432-0.835 c-0.375-0.054-0.739-0.097-1.104-0.139c-4.842-0.6-9.449-0.718-14.559-0.686c-1.778,0-3.621,0.032-5.55,0.054 c-1.918,0.032-3.792,0.118-5.571,0.246c-6.621,0.461-11.41,6.567-10.242,13.124c1.703,9.674,2.668,18.813,3.032,27.116 c0.086,1.875,0.15,3.685,0.171,5.464c0.107,6.953-0.214,13.231-0.846,18.641c-0.011,0.118-0.032,0.236-0.043,0.343 c-0.3,2.464-0.664,4.735-1.093,6.814c-0.128,0.654-0.268,1.275-0.418,1.885C91.311,244.245,90.807,246.505,90.464,247.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M146.288,247.64c0,4.77-35,7.03-55.82,0.15c0.34-1.28,0.84-3.55,1.14-4.84 c0.15-0.61,0.29-1.23,0.42-1.89c0.43-2.08,0.79-4.35,1.09-6.81c0.01-0.11,0.04-0.23,0.05-0.34c0.63-5.41,0.95-11.69,0.84-18.64 c-0.02-1.78-0.08-3.59-0.17-5.47c-0.12-2.75-0.3-5.58-0.57-8.5c-0.16-1.88-0.35-3.8-0.58-5.74c-0.48-4.16-1.1-8.46-1.88-12.87 c-1.17-6.56,3.62-12.67,10.24-13.13c1.78-0.13,3.65-0.21,5.57-0.24c1.93-0.03,3.77-0.06,5.55-0.06 c5.11-0.03,9.72,0.09,14.56,0.69c0.37,0.04,0.73,0.08,1.1,0.14c1.81,0.23,3.66,0.53,5.44,0.83c7.7,1.33,13.22,8.32,12.55,16.1 c-0.85,10.21,6.84,16.44-3.01,23.33C141.538,219.1,146.288,234.21,146.288,247.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M103.658,185.65l-10.39,15.65c-0.16-1.88-0.35-3.8-0.58-5.74v-0.04L103.658,185.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M127.833,187.127c0,0.369,0.299,0.668,0.668,0.668c0.369,0,0.668-0.299,0.668-0.668 c0-0.369-0.299-0.668-0.668-0.668C128.132,186.459,127.833,186.758,127.833,187.127z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4a4844"
    },
    cx: 128.906,
    cy: 193.131,
    r: 0.668
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4a4844"
    },
    cx: 128.906,
    cy: 199.241,
    r: 0.668
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M112.169,169.262c4.932,8.666,16.534,13.856,16.534,13.856c1.566-3.884,1.075-10.11-0.871-13.031 c-0.375-0.054-0.739-0.097-1.104-0.139C121.886,169.348,117.28,169.23,112.169,169.262z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M127.964,172.666c0.042,0.13,0.097,0.261,0.182,0.395c1.678,2.646-0.146,5.063-3.033,4.855 c-0.281-0.02-0.556-0.059-0.826-0.113c-1.037-0.208-1.998-0.741-2.716-1.518c-0.003-0.003-0.006-0.007-0.009-0.01 c-3.459-3.754-7.18-6.599-7.18-6.599c4.338-2.325,5.923-10.583,6.326-15.742l6.735,8.575l1.261,1.872 c-0.609,1.079-1.154,2.2-1.46,3.311C126.746,169.416,126.796,171.128,127.964,172.666z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M115.049,169.257c0,0-4.034-1.049-7.21,0l6.543,11.243c3.446-2.511,7.393,0.748,14.322,2.618 C128.704,183.118,120.449,178.967,115.049,169.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M115.049,169.257c0,0-4.034-1.049-7.21,0l6.543,11.243c3.446-2.511,7.393,0.748,14.322,2.618 C128.704,183.118,120.449,178.967,115.049,169.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M126.949,169.771c0,0,3.997-0.733,6.315,1.151c0,0,1.336,4.473,1.871,8.848 c0,0-3.846-1.92-6.432,3.348C128.704,183.118,130.012,174.727,126.949,169.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M126.949,169.771c0,0,3.997-0.733,6.315,1.151c0,0,1.336,4.473,1.871,8.848 c0,0-3.846-1.92-6.432,3.348C128.704,183.118,130.012,174.727,126.949,169.771z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.244,167.693c0.306-1.112,0.851-2.232,1.46-3.311l-1.261-1.872l-4.241,0.097 C123.202,162.606,124.315,166.029,127.244,167.693z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M119.475,144.741c-0.675,8.477-1.138,12.051,2.419,16.95c5.351,7.369,15.713,6.304,18.858-1.81 c2.831-7.304,3.459-19.94-4.14-24.418C129.126,131.051,120.15,136.264,119.475,144.741"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.338,150.29c-4.25-1.13-2.58-5.52-2.58-5.52l6.26,0.97 C125.018,145.74,125.588,151.41,121.338,150.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M138.497,136.25c0,0-0.109,4.688-5.859,4.938s-5.246,8.749-11.685,7.406 c-6.44-1.343-3.252-9.343-0.502-11.468S129.982,128.625,138.497,136.25z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M137.219,157.806c0,0-4.129-1.867-5.037-3.666c0,0-0.606,3.216,1.557,4.402 C135.902,159.728,137.219,157.806,137.219,157.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M133.425,148.521c-0.096,0.684,0.189,1.29,0.636,1.353c0.447,0.063,0.888-0.441,0.984-1.126 c0.096-0.684-0.188-1.29-0.636-1.353C133.962,147.333,133.521,147.837,133.425,148.521"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M140.379,149.652c-0.096,0.685,0.189,1.29,0.636,1.353c0.447,0.063,0.888-0.441,0.984-1.126 c0.096-0.684-0.188-1.29-0.636-1.353C140.915,148.464,140.475,148.968,140.379,149.652"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.16,148.537l1.71-0.243C142.87,148.294,141.846,149.46,141.16,148.537"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5652"
    },
    d: "M137.825,149.511c0,0,0.925,1.979,1.984,3.734c0.344,0.57,0.087,1.32-0.548,1.527 c-1.09,0.355-2.229,0.425-2.229,0.425L137.825,149.511z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M115.667,150.142c0.526,1.715,1.701,2.91,2.894,3.432c1.795,0.784,3.011-1.134,2.779-3.288 c-0.209-1.938-1.395-4.682-3.325-4.538C116.113,145.889,115.066,148.182,115.667,150.142"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M131.551,145.783c0.107,0,0.215-0.044,0.294-0.127c1.243-1.316,2.715-1.068,2.732-1.066 c0.218,0.038,0.432-0.106,0.472-0.327c0.04-0.221-0.107-0.431-0.327-0.472c-0.077-0.014-1.925-0.327-3.467,1.308 c-0.153,0.163-0.145,0.42,0.017,0.574C131.35,145.747,131.45,145.783,131.551,145.783"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M143.57,147.013c0.1,0.008,0.204-0.019,0.289-0.088c0.174-0.14,0.201-0.396,0.062-0.571 c-1.408-1.749-3.274-1.584-3.354-1.576c-0.223,0.023-0.386,0.221-0.363,0.445c0.022,0.222,0.221,0.385,0.443,0.364 c0.073-0.007,1.523-0.114,2.641,1.277C143.361,146.953,143.463,147.005,143.57,147.013"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M134.206,147.406l1.71-0.243C135.916,147.163,134.892,148.329,134.206,147.406"
  })))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#263238"
    },
    x1: 118.763,
    y1: 144.771,
    x2: 125.013,
    y2: 145.743
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4844"
    },
    d: "M82.218,222.32c3.49,5.6,7.38,11.23,11.19,16.78l-5.89,5.3c-5.28-4.72-10.15-9.66-14.81-15.08 c-2.34-2.72-4.57-5.55-6.7-8.83c-0.53-0.83-1.05-1.69-1.55-2.65c-0.5-0.96-0.99-1.99-1.43-3.29c-0.22-0.64-0.42-1.38-0.57-2.28 c-0.14-0.89-0.27-1.97-0.03-3.49c0.25-1.39,0.6-2.22,0.91-2.97c0.31-0.74,0.62-1.29,0.92-1.85c1.2-2.11,2.37-3.63,3.54-5.16 c1.18-1.51,2.36-2.92,3.55-4.29c2.42-2.7,4.84-5.29,7.35-7.77c4.99-4.98,10.08-9.66,15.55-14.14l10.39,12.17l-14.96,13.46 c-2.45,2.27-4.91,4.49-7.2,6.78c-1.16,1.12-2.29,2.25-3.33,3.37c-1.03,1.09-2,2.25-2.6,3.06c-0.01,0.02-0.03,0.03-0.04,0.05 c0.07,0.19,0.14,0.4,0.22,0.61c0.23,0.59,0.51,1.24,0.81,1.91C78.798,216.69,80.498,219.51,82.218,222.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M82.218,222.32c3.49,5.6,7.38,11.23,11.19,16.78l-5.89,5.3 c-5.28-4.72-10.15-9.66-14.81-15.08c-2.34-2.72-4.57-5.55-6.7-8.83c-0.53-0.83-1.05-1.69-1.55-2.65c-0.5-0.96-0.99-1.99-1.43-3.29 c-0.22-0.64-0.42-1.38-0.57-2.28c-0.14-0.89-0.27-1.97-0.03-3.49c0.25-1.39,0.6-2.22,0.91-2.97c0.31-0.74,0.62-1.29,0.92-1.85 c1.2-2.11,2.37-3.63,3.54-5.16c1.18-1.51,2.36-2.92,3.55-4.29c2.42-2.7,4.84-5.29,7.35-7.77c4.99-4.98,10.08-9.66,15.55-14.14 l10.39,12.17l-14.96,13.46c-2.45,2.27-4.91,4.49-7.2,6.78c-1.16,1.12-2.29,2.25-3.33,3.37c-1.03,1.09-2,2.25-2.6,3.06 c-0.01,0.02-0.03,0.03-0.04,0.05c0.07,0.19,0.14,0.4,0.22,0.61c0.23,0.59,0.51,1.24,0.81,1.91 C78.798,216.69,80.498,219.51,82.218,222.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M93.015,236.619c0,0,6.644,2.464,7.669,3.758s-5.498,8.639-8.03,9.667 c-2.532,1.028-1.228-2.021-1.228-2.021s-3.27,0.763-4.796-1.719C85.104,243.822,86.905,237.034,93.015,236.619z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M163.734,255.636c0,0,0.601-0.133,1.763-1.73c1-1.375,1.037-2.772,1.098-3.602l-4.195,3.553 c0,0-3.73-1.428-6.031,0.262c-4.641,3.41-3.329,7.249-2.793,8.359c0.535,1.11,4.373,0.428,7.032-1.778 C163.268,258.495,163.734,255.636,163.734,255.636z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.e63e97a15754de94051995030f9037c9.svg";
export { ForwardRef as ReactComponent };